<template>
  <div class="childtrackingsystem-grafic">
    <div class="row bg-white">
      <div class="col-md-2">
        <br>
        <b>Kinderen</b>
      </div>
      <div class="col-md-10">
        <br>
        <select
          id="idChild"
          v-model="selectedChild"
          class="form-control"
          style="width:300px;"
          @change="childSelect($event)"
        >
          <option value="0">
            Kies kind
          </option>
          <option 
            v-for="child in childrenCTS" 
            :key="child.id" 
            :value="child.id"
          >
            {{ child.full_name }}
          </option>
        </select>
        <br>
      </div>
    </div>
    <div id="viewDevelopmentArea">
      <div
        v-for="childDetails in chartDataDevelopmentArea"
        :key="childDetails.id" 
        class="row bg-white"
      >
        <div class="col-md-12">
          <table style="border:0;width:100%;">
            <tr class="preHeader">
              <th style="width:400px; height:50px;padding-left: 15px;">
                {{ childDetails.id }}. {{ childDetails.name }}
              </th><th />
            </tr>
          </table>
          <chart
            :datasets="childDetails.datasets"
            :labels="childDetails.labels"
            :chartoptions="chartOptions"
          />
        </div>
      </div>
    </div>
    <div
      v-if="isLoading"
      class="modalLoader"
    >
      <img
        src="../../assets/img/loading.gif"
        alt="Loading"
        style="width: 80px; height: 80px;"
      >
    </div>
  </div>
</template>
<script>
import Chart from '@/components/Chart.vue'

export default {
  name: 'ChildtrackingsystemGrafic',
  components: {Chart},
  data() {
    return {
      selectedChild: 0,
      categories: [],
      childrenCTS: [],
      results: [],
      isLoading: false,
      loadedChart: true,
      chartDataDevelopmentArea: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "Kind traject"
        }
      }
    }
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken
    },
    session() {
      return this.$store.getters.session
    },
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
    this.getResults()
  },
  methods: {
    getResults() {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/grafic', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idChild: this.selectedChild,
        idCategory: this.selectedCategory,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        showPresentOnly: this.$store.showPresentChildrenOnly
      }).then((response) => {
        this.isLoading = false
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
          this.chartDataDevelopmentArea = response.chartDataDevelopmentArea
          this.childrenCTS = response.children
          this.categories = response.categories
        }
      })
    },
    childSelect(event) {
      this.selectedChild = event.target.value
      this.getResults()
      return event.target.value
    }
  }
}
</script>

<style>
.modalLoader {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 100px;
  width: 100%;
  height: 100%;
  overflow: auto;
  text-align: center;
  vertical-align: middle;
}

.preHeader {
  color: #445161;
  background-color: #dedee7;
}
</style>